import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function InactiveUsersTable() {
  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [sortable, setSortable] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [goToPage, setGoToPage] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);

  const { pageNo } = useParams();
  const navigate = useNavigate(null);

  useEffect(() => {
    setCurrentPage(parseInt(pageNo) || 1);
    setGoToPage(parseInt(pageNo) || 1);
    getInactiveUsers();
  }, []);

  useEffect(() => {
    getInactiveUsers();
  }, [currentPage, searchTerm, recordsPerPage]);

  const handleTableSort = (column) => {
    let order = "asc";
    // Toggle sortOrder if the same column is clicked
    if (column === sortable) {
      order = sortOrder === "asc" ? "desc" : "asc";
    }
    setSortable(column);
    setSortOrder(order);
  };

  const handlePrevious = () => {
    navigate(`/admin-panel/user/inactive-users/${currentPage - 1}`);
    setCurrentPage(currentPage - 1);
    setGoToPage(currentPage - 1);
  };

  const handleNext = () => {
    navigate(`/admin-panel/user/inactive-users/${currentPage + 1}`);
    setCurrentPage(currentPage + 1);
    setGoToPage(currentPage + 1);
  };

  const handleGoToPage = (page) => {
    if (!page) {
      navigate(`/admin-panel/user/inactive-users/${goToPage}`);
    } else {
      navigate(`/admin-panel/user/inactive-users/${page}`);
      setCurrentPage(page);
    }
    setGoToPage(page);
  };

  // Fetching Data
  const getInactiveUsers = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("sansadToken");
      const headers = {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };
      if(currentPage < 1){
        setCurrentPage(1);
        setGoToPage(1);
        setSearchTerm("");
        toast.error("Page number should be greater than or equal to 1");
        return;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/admin/get-users?status=Inactive&page=${currentPage}&search=${searchTerm}&limit=${recordsPerPage}`,
        {
          headers: headers,
        }
      );
      if (response.data.statusCode === 200) {
        setData(response.data.result.users);
        setTotalRecords(response.data.result.totalRecords);
        setCurrentPage(response.data.result.currentPage);
        setTotalPages(response.data.result.totalPages);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  return (
    <div>
      {/* InActive Users */}
      <ToastContainer />
      <div className="bg-white md:p-10 p-3 rounded-xl shadow-md mt-8">
        <div className="flex justify-between items-center">
          <h2 className="text-xl font-medium">Inactive Users</h2>
          <div className="flex justify-center gap-4">
            <div className="">
              <input
                type="text"
                className="h-[40px] w-[250px] rounded-xl border-2 border-gray-300 px-3 text-sm !outline-none"
                placeholder="Search Here..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="flex flex-col relative -top-1">
              <span className="text-xs mb-0.5">Per Page</span>
              <select
                name="perPage"
                id="perPage"
                className="border border-[grey] rounded-md h-[22px] text-sm !outline-none"
                value={recordsPerPage}
                onChange={(e) => setRecordsPerPage(e.target.value)}
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="30">30</option>
                <option value="50">50</option>
              </select>
            </div>
            <div className="flex flex-col relative -top-1">
              <span className="text-xs mb-0.5">Go to</span>
              <input
                type="number"
                className="border border-[grey] rounded-md w-[50px] text-xs h-[22px] px-1 !outline-none"
                value={goToPage}
                onChange={(e) => {
                  handleGoToPage(e.target.value);
                }}
              />
            </div>
          </div>
        </div>
        <div className="flex gap-4 justify-between flex-wrap mt-10">
          <table className="w-full text-center">
            <thead>
              <tr className="border-b">
                <td
                  className="font-medium py-4 cursor-pointer"
                  // onClick={() => handleTableSort("userName")}
                >
                  UserName{" "}
                  {/* {sortable === "userName" ? (
                    <i className="fa fa-sort-amount-asc ml-2"></i>
                  ) : (
                    <i className="fa fa-sort-amount-desc ml-2"></i>
                  )} */}
                </td>
                <td
                  className="font-medium py-4 cursor-pointer"
                  // onClick={() => handleTableSort("fullName")}
                >
                  Full Name{" "}
                  {/* {sortable === "fullName" ? (
                    <i className="fa fa-sort-amount-asc ml-2"></i>
                  ) : (
                    <i className="fa fa-sort-amount-desc ml-2"></i>
                  )} */}
                </td>

                <td
                  className="font-medium py-4 cursor-pointer"
                  // onClick={() => handleTableSort("email")}
                >
                  Email{" "}
                  {/* {sortable === "email" ? (
                    <i className="fa fa-sort-amount-asc ml-2"></i>
                  ) : (
                    <i className="fa fa-sort-amount-desc ml-2"></i>
                  )} */}
                </td>
                <td className="font-medium py-4 cursor-pointer">Actions </td>
              </tr>
            </thead>
            <tbody>
              {!loading ? (
                data.length > 0 ? (
                  data.map((user) => (
                    <tr key={user._id} className="border-b">
                      <td className="py-3 text-sm">{user.userName}</td>
                      <td className="py-3 text-sm">{user.fullName}</td>
                      <td className="py-3 text-sm">{user.email}</td>
                      <td className="py-3 text-sm flex justify-center gap-x-3">
                        <button
                          className="h-[36px] w-[36px] bg-[#01b208] rounded-full"
                          title="View User"
                        >
                          <i className="fa fa-eye text-white"></i>
                        </button>
                        <button
                          className="h-[36px] w-[36px] bg-[#ff8a00] rounded-full"
                          title="Edit User"
                        >
                          <i className="fa fa-edit text-white"></i>
                        </button>
                        {user.status === "Active" ? (
                          <button
                            className="h-[36px] w-[36px] bg-[#ff4141] rounded-full"
                            title="Block User"
                          >
                            <i className="fa fa-user text-white"></i>
                          </button>
                        ) : (
                          <button
                            className="h-[36px] w-[36px] bg-[#ff4141] rounded-full"
                            title="Unblock User"
                          >
                            <i className="fa fa-user-times text-white"></i>
                          </button>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <td colSpan={4} className="text-center">
                    <p className="text-center w-full mt-10">No results found</p>
                  </td>
                )
              ) : (
                <td colSpan={4} className="text-center">
                  <p className="text-center w-full mt-10">Loading ...</p>
                </td>
              )}
            </tbody>
          </table>
          <div className="flex justify-between items-center w-full mt-6">
            <div className="">
              <span className="text-[13px] text-gray-500">
                Showing {(currentPage - 1) * recordsPerPage + 1} to{" "}
                {currentPage * recordsPerPage > totalRecords
                  ? totalRecords
                  : currentPage * recordsPerPage}{" "}
                out of {totalRecords}
              </span>
            </div>
            <div className="flex justify-center items-center gap-x-3">
              <button
                className="h-[32px] w-[32px] bg-[#2c2c38] rounded-md text-white text-sm"
                disabled={currentPage === 1}
                onClick={handlePrevious}
              >
                <i className="fa fa-chevron-left"></i>
              </button>
              <span className="text-[13px] text-gray-500">
                Page {currentPage} of {totalPages}
              </span>
              <button
                className="h-[32px] w-[32px] bg-[#2c2c38] rounded-md text-white text-sm"
                disabled={currentPage === totalPages}
                onClick={handleNext}
              >
                <i className="fa fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
